(function() {

    var logoPreviewApp;
    var el;

    this.bootstrap = function(_el) {
        el = _el;

        angular.element(el).attr('ng-app', 'logoEditorPreview');
        angular.element(el).attr('ng-controller', 'logoEditorPreviewController');

        logoPreviewApp = angular.module('logoEditorPreview', ['ngSanitize']);
        // HACK: set an empty defaultFontList value due to changes to the diyfontsproviders service
        logoPreviewApp.value('defaultFontList', []);

        /* load directives and services */
        diy.angular.loadDirectives(logoPreviewApp, ['diyfontsize', 'diytoggle', 'diycombobox', 'diyfontfamily', 'diyradio', 'diyslider']);
        diy.angular.loadFactories(logoPreviewApp, ['diyfileupload', 'diyfontsprovider', 'diyl10n']);

        logoPreviewApp.controller('logoEditorPreviewController', ["$scope", "$http", "$timeout", "diyfontsprovider",
            function ($scope, $http, $timeout, diyfontsprovider) {

                //$scope.$timeout = $timeout;

                $scope.standardFonts = diyfontsprovider.getStandardFonts();

                /**
                 * angularjs supports && and || inside it's directives, as it's plain JavaScript evaluated.
                 * The problem is that our output MUST be valid XML, so it will not support a & character inside
                 * an attribute. Because of this, logicalOr and logicalAnd functions have been created
                 */
                $scope.logicalAnd = function (a, b) {
                    return (a && b);
                };
                $scope.logicalOr = function (a, b) {
                    return (a || b);
                };

                $scope.$watch('data', function (newValue, oldValue) {
                    if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
                        $scope.style = {
                            text: {
                                cssText: [
                                    'font-family:' + newValue['fontFamily'] + '! important;',
                                    'font-size:' + newValue['fontSize'] + 'px' + ' !important;',
                                    'text-align:'+  newValue['align'] + ' !important;',
                                    'font-style:' + newValue['fontStyle'] + ' !important;',
                                    'font-weight:'+ newValue['fontWeight'] + ' !important;',
                                    'display:' + ((newValue['type'] == 'text' && newValue.text.length !=0)? 'inline-block;' : 'none;')
                                ].join("")
                            },
                            position: {
                                cssText: [
                                    'text-align:' + newValue['align'] + ' !important;',
                                    'padding:' + (
                                        (
                                            (newValue['type'] == 'text' && newValue.text.length !=0) ||
                                            (newValue['type'] == 'image' && newValue.logoImageExists)
                                        ) ?
                                        newValue['logoSpacing'] + 'px 0;' :
                                        '0 0;'
                                    )
                                ].join("")
                            },
                            logo: {
                                cssText: [
                                    'width:' + Math.floor(newValue['imageWidth']) + 'px;'
                                    //'height:' + Math.floor(newValue['imageHeight']) + 'px;'
                                ].join("")
                            }
                        };

                        /**
                         * if a new image is uploaded or the logoType is switched, scroll to editor
                         */
                        if(oldValue != undefined && (newValue.imageUrl != oldValue.imageUrl || newValue.type != oldValue.type)){
                           $scope.updateEditorPosition();
                        }
                    }
                }, true);


                $scope.refreshPreview = function (newData){
                      $timeout(function(){
                          $scope.data = newData;
                      });
                };
                $scope.updateEditorPosition = function (){
                    $timeout(function(){
                        diy.module.logo.logo.placeEditor();
                        diy.module.logo.logo.focusEditor();
                    },100);
                }
            }
        ]);

        logoPreviewApp
            .filter('newlines', function () {
                return function (text) {
                    text = text + '';
                    return text.replace(/\n/g, '<br/>');
                }
            })
            .filter('noHTML', function () {
                return function (text) {
                    text = text + '';
                    return text
                        .replace(/&/g, '&amp;')
                        .replace(/>/g, '&gt;')
                        .replace(/</g, '&lt;');
                }
            });

        angular.bootstrap(_el, [ 'logoEditorPreview' ]);
    };


    this.init = function(jsonData) {
        this.run(function(scope) {
            scope.data = jsonData;
            scope.updateEditorPosition();
        });
    };


    this.repaint = function(jsonData) {
        this.run(function(scope){
            scope.refreshPreview(jsonData);
        });

    };

    /**
     * gets the scope from the theming app
     */
    this.getScope = function() {
        return angular.element(el).scope();
    };

    /**
     * run internal theming code from outside
     * (eg ajax requests, callbacks, setTimeouts etc)
     */
    this.run = function(f) {
        var scope = this.getScope();
        scope && scope.$apply(f);
    };

    return this;
}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/logo/js/logoPreviewApp.js
 ** module id = 1140
 ** module chunks = 0
 **/